import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@circle-react/contexts";
import type { Event } from "@circle-react/types/Event";
import { Form } from "@circle-react-uikit/Form";
import { Typography } from "@circle-react-uikit/Typography";
import { FormItem } from "../../../Common";
import { LOCATION_TYPES } from "../../../utils";
import { LocationContent } from "./LocationContent";

interface LocationProps {
  event: Event;
  setLocationType: (locationType: string) => void;
}

export const Location = ({ event, setLocationType }: LocationProps) => {
  const { currentCommunity } = usePunditUserContext();
  const hasSupportForLiveStreams =
    currentCommunity?.supports_live_streams ?? false;
  const isWhiteLabeled = currentCommunity?.white_label ?? false;

  const locationTypeOptions = [
    {
      label: t(
        "events.create_modal.event_setting_attributes.location_type_in_person",
      ),
      value: LOCATION_TYPES.IN_PERSON,
    },
    {
      label: t(
        "events.create_modal.event_setting_attributes.location_type_virtual",
      ),
      value: LOCATION_TYPES.VIRTUAL,
    },
    {
      label: isWhiteLabeled
        ? t("events.location_types.live_stream")
        : t(
            "events.create_modal.event_setting_attributes.location_type_live_stream",
          ),
      value: LOCATION_TYPES.LIVE_STREAM,
      hidden: !hasSupportForLiveStreams,
    },
    {
      label: isWhiteLabeled
        ? t("events.location_types.live_room")
        : t(
            "events.create_modal.event_setting_attributes.location_type_live_room",
          ),
      value: LOCATION_TYPES.LIVE_ROOM,
      hidden: !hasSupportForLiveStreams,
    },
    {
      label: t(
        "events.create_modal.event_setting_attributes.location_type_tbd",
      ),
      value: LOCATION_TYPES.TBD,
    },
  ];

  return (
    <div className="my-6 md:mb-8 md:mt-16">
      <Typography.TitleMd>
        {t("events.create.form.event_location")}
      </Typography.TitleMd>
      <div className="flex items-stretch">
        <div className="w-full">
          <FormItem
            name="event_setting_attributes.location_type"
            placeholder={t(
              "events.create_modal.event_setting_attributes.location_type_placeholder",
            )}
            rules={{
              required: t(
                "events.create_modal.event_setting_attributes.location_required_error",
              ),
            }}
            translationRoot="events.create.form"
          >
            <Form.AnimatedSelect
              name="event_setting_attributes.location_type"
              fullWidth
              options={locationTypeOptions}
              allowEmpty
              dataTestId="event-location"
            />
          </FormItem>
        </div>
      </div>
      <LocationContent setLocationType={setLocationType} event={event} />
    </div>
  );
};
